import styled from "styled-components";
import { media } from "../../layouts/utils";

export const WrapperContainer = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const HeaderContainer = styled.div`
  max-width: 1444px;
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;

  ${media.wide`
        height: 100%;
        max-width: 100%;
        padding: 0;
        align-items: baseline;
    `}
`;

export const PartnerContainer = styled.div`
  height: 55px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (max-width: 768px) {
    justify-content: flex-end;
  }

  ${media.wide`
    align-self: center;
  `}
`;

export const PartnerImg = styled.img`
  object-fit: contain;
  max-width: 90%;
  max-height: 90%;
  width: auto;
  height: auto;

  ${media.wide`
      padding-top: 0px;
      padding-left: 48px;
    `}

  @media (max-width: 768px) {
    max-width: 75%;
    max-height: 75%;
    margin-right: 17px;
    width: 100%;
  }
`;

export const BlocoInterno = styled.div`
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.12);
  height: 90px;

  ${media.wide`
        height: 56px;
        max-width: 100%;
        padding: 0 8px 0 24px;
    `}
`;

export const ImgLogo = styled.div`
  margin-left: 66px;
  cursor: pointer;
  width: 130px;
  padding-top: 12px;

  ${media.wide`
		margin-left:1rem;
		width: 68px;
		height: 28px;
		background-size: cover;
	`}
  ${media.phone`
   margin-left: 0;
  `}
`;
